module.exports = __webpack_public_path__ + "img/card-title-point-sm.bda0684b.svg";